import React from 'react';

import { LoadingScreen } from '@/components/loaders/LoadingScreen';
import ShiplexLogo from '@/components/ui/ShiplexLogo';
import { useTranslation } from 'react-i18next';

import { LoginFooter } from './components/LoginFooter';
import { LoginForm } from './components/LoginForm';
import { SocialButtons } from './components/SocialButtons';
import { useLogin } from './hooks/useLogin';

export const LoginScreen: React.FC = () => {
  const { t } = useTranslation();

  const { error, loading, isCreatingAccount, isClerkLoading, submitEmail, submitPassword, handleSocialLogin } =
    useLogin();

  if (isClerkLoading) {
    return <LoadingScreen message="loading.session" />;
  }

  if (isCreatingAccount) {
    return <LoadingScreen message="loading.accountCreate" />;
  }

  return (
    <div className="relative flex h-screen scale-85 flex-col items-center justify-center 2xl:scale-100">
      <ShiplexLogo color="duotoneDark" className="h-10 w-auto" />
      <h3 className="pt-9 text-black/65">{t('auth.login.title')}</h3>

      <SocialButtons onLogin={handleSocialLogin} />

      <LoginForm loading={loading} error={error} submitEmail={submitEmail} submitPassword={submitPassword} />

      <LoginFooter className="mb-[6vh]" />
    </div>
  );
};
